<template>
  <div style="margin: 60px 0">
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div>
        <h1 style="font-size: large; font-weight: 700">Product Catalog</h1>
        <p style="color: #6b7280; font-size: 14px">
          View and manage seller's product catalog
        </p>
      </div>

      <div style="display: flex; align-items: center; gap: 16px">
        <a-button
          :loading="exportLoading"
          @click="exportExcel"
          style="border-radius: 6px; background: #f9fafb; color: #374151"
          icon="download"
        >
          Export
        </a-button>
        <!-- <a-button
          :loading="exportLoading"
          @click="exportExcel"
          style="border-radius: 6px; background: #26a246; color: #ffffff"
          icon="plus"
        >
          Add Product
        </a-button> -->
      </div>
    </div>

    <!-- product table -->
    <div>
      <!-- Filters & Search -->
      <div>
        <a-row
          :gutter="[16, { xs: 8, sm: 16, md: 24, lg: 32 }]"
          style="margin-top: 10px"
          type="flex"
          align="top"
        >
          <a-col :span="6">
            <label
              style="font-weight: 500; font-size: 13px; margin-bottom: 4px; display: block"
            >
              Search
            </label>
            <a-input
              v-model="searchText"
              placeholder="Search by Product Name or SKU..."
              style="width: 100%"
              allow-clear
              prefix-icon="search"
              :xs="24"
              :sm="12"
              :md="6"
            />
          </a-col>
          <!-- <a-col :span="6">
            <label
              style="font-weight: 500; font-size: 13px; margin-bottom: 4px; display: block"
            >
              All Categories
            </label>
            <a-select
              v-model="filters.category"
              placeholder="All Categories"
              style="width: 100%"
              allow-clear
            >
              <a-select-option value="Vitamins & Minerals"
                >Vitamins & Minerals</a-select-option
              >
              <a-select-option value="Antibiotics & Vitamins"
                >Antibiotics & Vitamins</a-select-option
              >
            </a-select>
          </a-col> -->
        </a-row>
      </div>

      <!-- Product Table -->
      <div style="margin-top: 40px">
        <a-table
          :columns="productColumns"
          :data-source="products"
          row-key="productId"
          :loading="loading"
          :pagination="tablePagination"
          :scroll="{ x: 'max-content' }"
          style="background-color: #fafafa"
          @change="handleTableChange"
        >
          <template slot="actions" slot-scope="text, record">
            <a-button
              type="link"
              icon="eye"
              style="cursor: pointer; color: #26a246"
              @click="viewProduct(record)"
            />
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import sellersService from "../../../api/sellers.service";
import * as XLSX from "xlsx";

export default {
  name: "ProductCatalog",
  props: {
    sellerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchText: "",
      searchDebounceTimer: null,
      exportLoading: false,
      products: [],
      loading: false,
      filters: {
        status: null,
        category: null,
        financing: null,
      },
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
      },
      productColumns: [
        { title: "Product ID", dataIndex: "productId", key: "productId" },
        { title: "Product Name", dataIndex: "productName", key: "productName" },
        { title: "Category", dataIndex: "category", key: "category" },
        {
          title: "Manufacturer",
          dataIndex: "manufacturer",
          key: "manufacturer",
        },
        { title: "Quantity", dataIndex: "quantity", key: "quantity" },
        { title: "Cost Price", dataIndex: "costPrice", key: "costPrice" },
        {
          title: "Selling Price",
          dataIndex: "sellingPrice",
          key: "sellingPrice",
        },
        {
          title: "Profit Margin",
          dataIndex: "profitMargin",
          key: "profitMargin",
        },
        {
          title: "Actions",
          key: "actions",
          scopedSlots: { customRender: "actions" },
        },
      ],
      paymentTermsOptions: [
        "Next 30 days",
        "Next 15 days",
        "Next 60 days",
        "Due on Receipt",
        "Next 45 days",
        "Next 90 days",
      ],
    };
  },
  computed: {
    tablePagination() {
      return {
        current: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        total: this.pagination.totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} products`,
        showSizeChanger: false,
      };
    },
  },
  watch: {
    sellerId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchSellerProducts();
        }
      },
    },
    'pagination.pageIndex'() {
      this.fetchSellerProducts();
    },
    searchText() {
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.pagination.pageIndex = 1;
        this.fetchSellerProducts();
      }, 400);
    },
  },
  mounted() {
    console.log("seller ID", this.sellerId)
    this.fetchSellerProducts();
  },
  methods: {
    async fetchSellerProducts() {
      this.loading = true;
      const response = await sellersService.getSellerProductsCatalog(this.sellerId, {
        search: this.searchText,
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      });
      if (response.data?.code === 200) {
        const data = response.data.data;
        this.products = (data.results || []).map((product) => {
          return {
            ...product, // Keep the original product data
            productId: product.productCatalog?.productId || product.id,
            productName: product.productCatalog?.productName || "N/A",
            category: product.productCatalog?.category || "N/A",
            manufacturer: product.productCatalog?.manufacturer || "N/A",
            quantity: product.minimumStockQuantity || 0,
            costPrice: product.costPrice || 0,
            sellingPrice: product.sellingPrice || 0,
            profitMargin: product.profitMargin
              ? `${product.profitMargin.toFixed(1)}%`
              : "0%",
            status: product.status || "Active",
            genericName: product.productCatalog?.genericName || "N/A",
            productGroup: product.productCatalog?.productGroup || "N/A",
            targetSpecies: product.productCatalog?.targetSpecies || "N/A",
            diseasePrevented:
              product.productCatalog?.diseasePrevented || "N/A",
            countryOfOrigin: product.productCatalog?.countryOfOrigin || "N/A",
            packSize: product.productCatalog?.packSize || "N/A",
            unitWeight: product.productCatalog?.unitWeight || 0,
            unitMeasure: product.productCatalog?.unitMeasure || "N/A",
            minimumOrderQuantity: product.minimumOrderQuantity || 0,
          };
        });
        this.pagination.totalCount = data.totalCount || 0;
        this.pagination.pageIndex = data.pageIndex || this.pagination.pageIndex;
      } else {
        this.products = [];
        this.pagination.totalCount = 0;
      }
      this.loading = false;
    },
    handleTableChange(pagination) {
      if (pagination.current !== this.pagination.pageIndex) {
        this.pagination.pageIndex = pagination.current;
      }
    },
    async viewProduct(record) {
      try {
        console.log("View product called with record:", record);
        this.loading = true;
        // Ensure we have a valid record with productId for routing
        if (
          !record ||
          !record.productCatalog ||
          !record.productCatalog.productId
        ) {
          console.error(
            "Invalid record or missing productId for navigation:",
            record
          );
          this.$message.error("Cannot view product: Missing product ID.");
          return;
        }

        const productId = record.id;
        const sellerId = this.sellerId; // Get sellerId from props

        if (!sellerId) {
          console.error("Seller ID is missing from props for product navigation.");
          this.$message.error("Cannot view product: Seller ID missing.");
          return;
        }

        console.log(
          "Navigating to product details for productId:",
          productId,
          "and sellerId:",
          sellerId
        );
        this.$router.push(`/sellers/${sellerId}/products/${productId}`);
      } catch (error) {
        console.error("Error navigating to product details:", error);
        this.$message.error("Failed to navigate to product details.");
      } finally {
        this.loading = false;
      }
    },

    exportExcel() {
      this.exportLoading = true;
      try {
        // Prepare data for export (remove unwanted fields if necessary)
        const exportData = this.products.map(product => ({
          "Product ID": product.productId,
          "Product Name": product.productName,
          "Category": product.category,
          "Manufacturer": product.manufacturer,
          "Quantity": product.quantity,
          "Cost Price": product.costPrice,
          "Selling Price": product.sellingPrice,
          "Profit Margin": product.profitMargin,
          "Status": product.status,
          "Generic Name": product.genericName,
          "Product Group": product.productGroup,
          "Target Species": product.targetSpecies,
          "Disease Prevented": product.diseasePrevented,
          "Country of Origin": product.countryOfOrigin,
          "Pack Size": product.packSize,
          "Unit Weight": product.unitWeight,
          "Unit Measure": product.unitMeasure,
          "Minimum Order Quantity": product.minimumOrderQuantity,
        }));

        // Create worksheet and workbook
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Product Catalog");

        // Use XLSX.writeFile to trigger download
        XLSX.writeFile(workbook, "ProductCatalog.xlsx");
        this.$message.success("Exported to Excel!");
      } catch (error) {
        console.error("Excel export error:", error);
        this.$message.error("Failed to export Excel file.");
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style> 